export default __webpack_public_path__ + "static/media/NanumSquareB.5d53333f.woff";